export default {
  debug: true,

  logReduxActions: false,

  ga: {
    logEnabled: false
  },

  webApi: {
    secure: false,
    host: 'api.apli.local',
    path: '/'
  },

  idleMonitor: {
    awayDelay: 5 * 60 * 1000, // 5 minutes
    inactiveDelay: 5 * 60 * 1000, // 5 minutes after it enters the away status
    expiredDelay: 5 * 60 * 1000 // 5 minutes after it enters the inactive status
  },

  syncAuthTokensDelayInMilliseconds: 2 * 1000 // 2 sec
};



// WEBPACK FOOTER //
// ./src/config/env/development.js